module.exports = __webpack_public_path__ + "img/bgi2.9794717a.png";